import React from 'react';
import { Image, Typography } from 'tfc-components';

import cardImg from 'assets/images/home/card_1.png';
import cardImg2 from 'assets/images/home/card_2.png';
import extendSvg from 'assets/images/home/extend_images_card.svg';
import Section from 'components/organisms/Section';

const FeatureInside: React.FC = () => (
  <Section className="p-home_featureInside">
    <Section.Title sectionName="Advance Features" className="p-home_featureInside_titleSection">
      Build powerful agent
    </Section.Title>
    <div className="p-home_featureInside_wrap">
      <div className="p-home_featureInside_cardFrame">
        <Image imgSrc={extendSvg} extendClasses="p-home_featureInside_extend" alt="Google" ratio={1} />
        <div className="p-home_featureInside_content p-home_featureInside-first">
          <div className="p-home_featureInside_header">
            <Typography.Text extendClasses="p-home_featureInside_text f-16x20">
              Monitor dashboard
            </Typography.Text>
            <Typography.Heading type="h3" fontweight="600" extendClasses="p-home_featureInside_title f-24x30">
              Manage, Optimize, and Scale
            </Typography.Heading>
          </div>
          <div className="p-home_featureInside_imageContainer">
            <div className="p-home_featureInside_image">
              <Image imgSrc={cardImg} alt="Google" ratio={1816 / 1688} />
            </div>
          </div>
        </div>
      </div>
      <div className="p-home_featureInside_cardFrame">
        <Image imgSrc={extendSvg} extendClasses="p-home_featureInside_extend" alt="Google" ratio={1} />
        <div className="p-home_featureInside_content p-home_featureInside-second">
          <div className="p-home_featureInside_header">
            <Typography.Text extendClasses="p-home_featureInside_text f-16x20">
              AI Action
            </Typography.Text>
            <Typography.Heading type="h3" fontweight="600" extendClasses="p-home_featureInside_title f-24x30">
              Seamless integration, limitless possibilities
            </Typography.Heading>
          </div>
          <div className="p-home_featureInside_imageContainer">
            <div className="p-home_featureInside_image">
              <Image imgSrc={cardImg2} alt="Google" ratio={1816 / 1688} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Section>
);

export default FeatureInside;
